import { createFileRoute } from '@tanstack/react-router';
import LoginSignUpCard from 'src/features/auth/components/LoginSignUpCard';
import { SmartRedirect } from 'src/features/auth/contexts/SmartRedirect';
import { useAuthPageData } from 'src/shared/hooks/useAuthPageData';

export const Route = createFileRoute('/_auth/login')({
  head: () => ({
    meta: [{ title: 'Login | Tekst' }],
  }),
  component: LoginPage,
});

function LoginPage() {
  const { logo, dimensions, authOptions } = useAuthPageData();

  return (
    <SmartRedirect>
      <LoginSignUpCard
        variant="login"
        logo={logo ?? undefined}
        dimensions={dimensions}
        authOptions={authOptions ?? undefined}
      />
    </SmartRedirect>
  );
}
